import { Outlet } from 'react-router-dom';

import React from 'react';
import { Header } from '../organisms/Header';
import styled from 'styled-components';
import { ToastContainer } from '../molecules/ToastContainer';
import { Logo } from '../atoms';
import { EmployeeMainMenu, HeaderEmployee } from '../organisms';

export const EmployeeMainMenuLayout = () => {
    return (
        <Root className="mb-8">
            <ContentContainer>
                <HeaderEmployee/>
                <ToastContainer/>
                <div className="flex flex-row mt-4">
                    <EmployeeMainMenu className="mr-6 hidden md:block"/>
                    <div className="p-4 w-full">
                        <Outlet/>
                    </div>
                </div>
            </ContentContainer>
        </Root>
    );
};


const Root = styled.div`
    margin: 0 auto;
    min-height: 100vh;
    width: 100%;
`;
const ContentContainer = styled.div`
    width: 100%;
`;
